import { switchMap } from 'rxjs';
import { fromFetch } from 'rxjs/fetch';
import { searchCommunitySitePlans } from 'constants/routes'

/**
 * Retrieves community site plans associated to a given community id.
 * @param {Object} payload - The payload containing the list of community ids.
 * @returns {Observable} - An observable that emits the community site plans information.
 */
function searchCommunitySitePlansInformation(payload) {
  return fromFetch(searchCommunitySitePlans, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'Accept': 'application/json',
    },
    body: JSON.stringify(payload.communityIds),
  }).pipe(
    switchMap((response) => response.json())
  );
}

export default searchCommunitySitePlansInformation;